import React from 'react';
import CartBanner, { CART_BANNER_CONFIGS } from 'components/common/cart_banner';

const DisabledSoftwareAddonBanner = ({ enabled }) => {
  if (!enabled) return null;

  return <CartBanner config={CART_BANNER_CONFIGS.DISABLED_SOFTWARE_ADDON} />;
};

export default DisabledSoftwareAddonBanner;
